import React from 'react';
import './App.css';
import MainCarosel from './components/MainCarousel.js';
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Obituary from './components/Obituary.js';
import BurialSight from './components/BurialSight.js'
import { FacebookProvider, Like } from 'react-facebook';

class App extends React.Component {

  constructor (props){
    super(props);
    this.state={
        appId: '803693260169393',
       fbUrl: ''
    }
  }
  render(){
      return (
      <Router>
        <div className="App">
          <header className="App-header">
            <FacebookProvider appId={ this.state.appId }>
                <Like href={ this.state.fbUrl } colorScheme="light" showFaces share />
            </FacebookProvider>
            <p className="Header-memory">
              In loving memory of John Thomas Braun born 4-11-1947
            </p>
            <p className="Header-date">
              John Thomas Braun found peace on Thursday May 28 2020.
            </p>
          </header>

          <nav>
            <ul>
                <li>
                    <Link to='/'>Home</Link>
                </li>
                <li>
                    <Link to='/obituary'>Obituary</Link>
                </li>
                <li>
                    <Link to='/burial-sight'>Burial Sight</Link>
                </li>
            </ul>
          </nav>
          <Switch>
            <Route exact path='/' component={ MainCarosel } />
            <Route exact path='/obituary' component={ Obituary } />
            <Route exact path='/burial-sight' component={ BurialSight } />
          </Switch>

        </div>
      </Router>
      );
  }
}

export default App;
